import copy from 'copy-to-clipboard';
import { rem } from 'polished';
import React, { Component, MouseEventHandler } from 'react';
import styled from 'styled-components';

import { bokehTheme as theme } from '@vimeo/bokeh-theme';
import { translate } from '@vimeo/i18n-runtime';
import { Button, Notification, PopOver } from '@vimeo/iris/components';
import { ChevronDown } from '@vimeo/iris/icons';
import { Paragraph as P } from '@vimeo/iris/typography';

/**
 * Styles
 */

const ShareWrapper = styled.div`
  margin: 0 ${rem(10)};
`;

const DropdownWrapper = styled.div`
  cursor: pointer;
  padding: ${rem(10)} 0;
`;

const DropdownItem = styled.div`
  padding: ${rem(10)};
  label {
    cursor: pointer;
  }
  &:hover {
    background: ${theme.colors.gray['50']};
  }
`;

const Paragraph = styled(P)`
  margin: 0;
`;

const StyledButton = styled(Button)`
  > span {
    display: flex;
  }
  svg {
    width: ${rem(24)};
    height: ${rem(24)};
  }
`;

const StyledPopOver = styled(PopOver)`
  text-decoration: none;
`;

interface Props {
  canCreateEmbeddedPlaylists: boolean;
  embed: null | { html: string | null };
  openShare: MouseEventHandler;
}

interface State {
  menuOpen: boolean;
  showNotification: boolean;
}

class ShowcaseShareButton extends Component<Props, State> {
  state = {
    menuOpen: false,
    showNotification: false,
  };

  onCopy = (copyText: string) => {
    const didCopy = copy(copyText);
    this.setState({ showNotification: didCopy, menuOpen: !didCopy });
    // FA for successful copy?
  };

  render() {
    const { canCreateEmbeddedPlaylists, openShare, embed } = this.props;
    const { menuOpen, showNotification } = this.state;

    const MenuContent = (
      <DropdownWrapper role="dropdown">
        <DropdownItem
          onClick={(e) => {
            openShare(e);
            this.setState({ menuOpen: false });
          }}
        >
          <Paragraph size="2">{translate('Share showcase')}</Paragraph>
        </DropdownItem>
        {canCreateEmbeddedPlaylists && embed && embed.html && (
          <DropdownItem
            onClick={() => {
              if (embed && embed.html) {
                this.onCopy(embed.html);
              }
            }}
          >
            <Paragraph size="2">{translate('Copy embed code')}</Paragraph>
          </DropdownItem>
        )}
      </DropdownWrapper>
    );

    return (
      <ShareWrapper>
        <StyledPopOver attach="top" content={MenuContent} active={menuOpen}>
          <StyledButton
            format="secondary"
            icon={<ChevronDown />}
            iconPosition="right"
            onClick={() => this.setState({ menuOpen: !this.state.menuOpen })}
          >
            {translate('Share')}
          </StyledButton>
        </StyledPopOver>
        <Notification
          status="negative"
          showing={showNotification}
          onComplete={() => this.setState({ showNotification: false })}
          content={translate('Copied!')}
        />
      </ShareWrapper>
    );
  }
}

export default ShowcaseShareButton;
